import React, { Children } from 'react';
import { Layout } from '../components/Layout';
import { Container } from '../components/ui/Container';
export function PrivacyPage() {
  return <Layout data-id="element-357">
      <div className="bg-slate-50 py-12 border-b border-slate-200" data-id="element-358">
        <Container data-id="element-359">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-360">
            Privacy Policy
          </h1>
          <p className="text-slate-600" data-id="element-361">
            Last Updated: {new Date().toLocaleDateString()}
          </p>
        </Container>
      </div>

      <Container className="py-16 max-w-4xl" data-id="element-362">
        <div className="prose prose-slate max-w-none space-y-8" data-id="element-363">
          <section data-id="element-364">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-365">
              1. Introduction
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-366">
              DanyCredit LLC ("we," "our," or "us") is committed to protecting
              your privacy. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you visit our
              website danycredit.com and use our services.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-600 p-4 my-4" data-id="element-367">
              <p className="text-sm text-blue-900 font-medium" data-id="element-368">
                Important: DanyCredit provides educational and consulting
                services only. We are not a credit bureau, lender, or law firm.
              </p>
            </div>
          </section>

          <section data-id="element-369">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-370">
              2. Information We Collect
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-371">
              2.1 Personal Information You Provide
            </h3>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-372">
              We collect information that you voluntarily provide to us when
              you:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-373">
              <li data-id="element-374">Request a consultation through our contact forms</li>
              <li data-id="element-375">Subscribe to our educational content or newsletters</li>
              <li data-id="element-376">Communicate with us via email, phone, or other channels</li>
              <li data-id="element-377">Create an account or use our services</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-378">
              This information may include:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-379">
              <li data-id="element-380">Full name</li>
              <li data-id="element-381">Email address</li>
              <li data-id="element-382">Phone number</li>
              <li data-id="element-383">State of residence</li>
              <li data-id="element-384">Financial goals and consultation preferences</li>
              <li data-id="element-385">
                Any other information you choose to provide in forms or
                communications
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-386">
              2.2 Automatically Collected Information
            </h3>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-387">
              When you visit our website, we may automatically collect certain
              information about your device and usage patterns, including:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-388">
              <li data-id="element-389">IP address and browser type</li>
              <li data-id="element-390">Operating system and device information</li>
              <li data-id="element-391">Pages visited, time spent on pages, and navigation paths</li>
              <li data-id="element-392">Referring website or source</li>
              <li data-id="element-393">Date and time of access</li>
            </ul>
          </section>

          <section data-id="element-394">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-395">
              3. How We Use Your Information
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-396">
              We use the information we collect for the following purposes:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-397">
              <li data-id="element-398">
                <strong data-id="element-399">Service Delivery:</strong> To provide educational
                consulting services, respond to consultation requests, and
                communicate about your financial education goals
              </li>
              <li data-id="element-400">
                <strong data-id="element-401">Communication:</strong> To send you information about
                our services, educational content, updates, and respond to your
                inquiries
              </li>
              <li data-id="element-402">
                <strong data-id="element-403">Improvement:</strong> To analyze website usage and
                improve our services, content, and user experience
              </li>
              <li data-id="element-404">
                <strong data-id="element-405">Legal Compliance:</strong> To comply with applicable
                laws, regulations, and legal processes
              </li>
              <li data-id="element-406">
                <strong data-id="element-407">Security:</strong> To protect against fraud,
                unauthorized access, and other security risks
              </li>
            </ul>
          </section>

          <section data-id="element-408">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-409">
              4. Information Sharing and Disclosure
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-410">
              4.1 We Do Not Sell Your Data
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-411">
              DanyCredit LLC does not sell, rent, or trade your personal
              information to third parties for marketing purposes.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-412">
              4.2 Limited Sharing
            </h3>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-413">
              We may share your information only in the following circumstances:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-414">
              <li data-id="element-415">
                <strong data-id="element-416">Service Providers:</strong> With trusted third-party
                service providers who assist us in operating our website,
                conducting our business, or servicing you (e.g., email service
                providers, payment processors, hosting providers). These parties
                are contractually obligated to keep your information
                confidential.
              </li>
              <li data-id="element-417">
                <strong data-id="element-418">Legal Requirements:</strong> When required by law, court
                order, or government regulation, or to protect our rights,
                property, or safety.
              </li>
              <li data-id="element-419">
                <strong data-id="element-420">Business Transfers:</strong> In connection with a
                merger, acquisition, or sale of assets, your information may be
                transferred to the acquiring entity.
              </li>
              <li data-id="element-421">
                <strong data-id="element-422">With Your Consent:</strong> When you explicitly
                authorize us to share your information for a specific purpose.
              </li>
            </ul>
          </section>

          <section data-id="element-423">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-424">
              5. Cookies and Tracking Technologies
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-425">
              We use cookies and similar tracking technologies to enhance your
              experience on our website. Cookies are small data files stored on
              your device that help us:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-426">
              <li data-id="element-427">Remember your preferences and settings</li>
              <li data-id="element-428">Understand how you use our website</li>
              <li data-id="element-429">Improve website functionality and performance</li>
              <li data-id="element-430">Provide relevant content and advertising</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-431">
              You can control cookies through your browser settings. However,
              disabling cookies may limit your ability to use certain features
              of our website.
            </p>
          </section>

          <section data-id="element-432">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-433">
              6. Data Security
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-434">
              We implement industry-standard security measures to protect your
              personal information from unauthorized access, disclosure,
              alteration, or destruction. These measures include:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-435">
              <li data-id="element-436">
                Secure Socket Layer (SSL) encryption for data transmission
              </li>
              <li data-id="element-437">Secure servers protected by firewalls</li>
              <li data-id="element-438">
                Restricted access to personal information on a need-to-know
                basis
              </li>
              <li data-id="element-439">Regular security audits and updates</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-440">
              While we strive to protect your information, no method of
              transmission over the internet or electronic storage is 100%
              secure. We cannot guarantee absolute security.
            </p>
          </section>

          <section data-id="element-441">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-442">
              7. Data Retention
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-443">
              We retain your personal information only for as long as necessary
              to fulfill the purposes outlined in this Privacy Policy, unless a
              longer retention period is required or permitted by law. When
              information is no longer needed, we will securely delete or
              anonymize it.
            </p>
          </section>

          <section data-id="element-444">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-445">
              8. Your Rights and Choices
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-446">
              Depending on your location, you may have the following rights
              regarding your personal information:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-447">
              <li data-id="element-448">
                <strong data-id="element-449">Access:</strong> Request access to the personal
                information we hold about you
              </li>
              <li data-id="element-450">
                <strong data-id="element-451">Correction:</strong> Request correction of inaccurate or
                incomplete information
              </li>
              <li data-id="element-452">
                <strong data-id="element-453">Deletion:</strong> Request deletion of your personal
                information, subject to legal and contractual obligations
              </li>
              <li data-id="element-454">
                <strong data-id="element-455">Opt-Out:</strong> Unsubscribe from marketing
                communications at any time
              </li>
              <li data-id="element-456">
                <strong data-id="element-457">Data Portability:</strong> Request a copy of your
                information in a structured, commonly used format
              </li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-458">
              To exercise any of these rights, please contact us at
              info@danycredit.com. We will respond to your request within a
              reasonable timeframe.
            </p>
          </section>

          <section data-id="element-459">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-460">
              9. Third-Party Links
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-461">
              Our website may contain links to third-party websites or services.
              We are not responsible for the privacy practices or content of
              these external sites. We encourage you to review the privacy
              policies of any third-party sites you visit.
            </p>
          </section>

          <section data-id="element-462">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-463">
              10. Children's Privacy
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-464">
              Our services are not directed to individuals under the age of 18.
              We do not knowingly collect personal information from children. If
              we become aware that we have collected information from a child
              without parental consent, we will take steps to delete that
              information promptly.
            </p>
          </section>

          <section data-id="element-465">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-466">
              11. Changes to This Privacy Policy
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-467">
              We may update this Privacy Policy from time to time to reflect
              changes in our practices or legal requirements. We will notify you
              of any material changes by posting the updated policy on our
              website with a new "Last Updated" date. Your continued use of our
              services after such changes constitutes acceptance of the updated
              policy.
            </p>
          </section>

          <section data-id="element-468">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-469">
              12. Contact Us
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-470">
              If you have questions, concerns, or requests regarding this
              Privacy Policy or our data practices, please contact us:
            </p>
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mt-4" data-id="element-471">
              <p className="font-semibold text-slate-900 mb-2" data-id="element-472">
                DanyCredit LLC
              </p>
              <p className="text-slate-700" data-id="element-473">390 NE 191ST ST STE 8123</p>
              <p className="text-slate-700" data-id="element-474">Miami, FL 33179</p>
              <p className="text-slate-700 mt-3" data-id="element-475">Email: info@danycredit.com</p>
              <p className="text-slate-700" data-id="element-476">Phone: 786-376-3985</p>
            </div>
          </section>

          <div className="bg-amber-50 border-l-4 border-amber-600 p-6 mt-8" data-id="element-477">
            <p className="text-sm text-amber-900 font-medium mb-2" data-id="element-478">
              Disclaimer
            </p>
            <p className="text-sm text-amber-800 leading-relaxed" data-id="element-479">
              DanyCredit LLC provides educational and consulting services only.
              We do not guarantee specific outcomes, credit score increases,
              approvals, or financial results. We are not a credit bureau,
              lender, or law firm. Results vary by individual financial profile.
            </p>
          </div>
        </div>
      </Container>
    </Layout>;
}